export const getCategoryFromUrl = (url: string) => {
    const urlData = url.split('catalog/');
    const catalogTail = urlData?.[1];

    if (!catalogTail || catalogTail[0] === '?') {
        return '';
    }

    const category = catalogTail.split('/')[0].split('?')[0].trim();

    return category;
};

export const getLandingSlugFromUrl = (url: string) => {
    const normalized = url.replace(/\/+$/, '');
    const slug = normalized.split('/').filter(Boolean).at(-1) || '';

    if (!slug || slug.includes('?') || slug.includes('catalog')) {
        return '';
    }

    return slug;
};
